import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Blog.css";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();
const url=process.env.REACT_APP_LINK
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(`${url}/api/blogs`);
        const data = await res.json();
        setBlogs(data);
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };
    fetchBlogs();
  }, []);

  const goToBlog = (blog) => {
    if (blog.slug) navigate(`/blogs/${blog.slug}`);
  };

  const getImageUrl = (path) => (path ? `${url}/${path}` : "");

  return (
    <div className="premium-blog-wrapper">
      <section className="premium-blog-hero">
        <div className="premium-blog-hero-overlay">
          <h1>Fresh Insights, Expert Advice</h1>
          <p>Your go-to space for premium property trends & tips</p>
        </div>
      </section>

      <section className="premium-blog-cards">
        {blogs.length > 0 ? (
          blogs.map((blog) => (
            <div key={blog.id} className="premium-blog-card">
              <div className="card-img-wrapper" onClick={() => goToBlog(blog)}>
                <img
                  src={getImageUrl(blog.image1)}
                  alt={blog.title}
                  className="premium-blog-img"
                />
              </div>
              <div className="premium-blog-card-body">
                <h2 onClick={() => goToBlog(blog)}>{blog.title}</h2>
                <p className="premium-blog-snippet">
                  {
                    (() => {
                      try {
                        const parsed = JSON.parse(blog.description);
                        return Array.isArray(parsed) ? parsed[0] : parsed;
                      } catch {
                        return blog.description || "";
                      }
                    })()
                  }
                </p>
                <button onClick={() => goToBlog(blog)} className="premium-read-btn">
                  Read More →
                </button>
              </div>
            </div>
          ))
        ) : (
          <p className="premium-no-blogs">No blogs available.</p>
        )}
      </section>

      <section className="premium-newsletter">
        <div className="newsletter-content">
          <h2>Join Our Inner Circle</h2>
          <p>Be the first to get our newest real estate updates</p>
          <form className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              className="newsletter-input"
            />
            <button className="newsletter-btn">Subscribe</button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Blog;